import * as React from 'react';
import { ModalScreen } from 'components/modal-screen';
import { ModalType } from 'components/modal-screen/ModalType';
import { convertToMonetary } from 'utilities/util';
import { IDivisionBreakdown } from 'views/job-costing/utils/CostAndRevenueHelpers';

interface IProps {
    visible: boolean;
    breakdown: IDivisionBreakdown;
    closeModal: () => void;
}

export const ProfitabilityBreakdownModal: React.FunctionComponent<IProps> = (props: IProps) => {
    const { rows, total } = props.breakdown;
    return (
        <ModalScreen
            title="Profitability Breakdown"
            id="profitability-breakdown"
            modalType={ModalType.s()}
            visible={props.visible}
            closeModal={props.closeModal}
            hideSecondaryButton={true}
            primaryButtonTitle="Close"
            primaryButtonFunc={props.closeModal}
        >
            <table className="status" id="ProfitabilityBreakdownTable">
                <thead>
                    <tr>
                        <td><strong>Division</strong></td>
                        <td className="align-text-right"><strong>Revenue</strong></td>
                        <td className="align-text-right"><strong>Cost</strong></td>
                        <td className="align-text-right"><strong>Profit</strong></td>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.division}>
                            <td>{row.division}</td>
                            <td className="align-text-right">{convertToMonetary(row.revenue)}</td>
                            <td className="align-text-right">{convertToMonetary(row.cost)}</td>
                            <td className="align-text-right">{convertToMonetary(row.profit)}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td><strong>{total.division}</strong></td>
                        <td className="align-text-right"><strong>{convertToMonetary(total.revenue)}</strong></td>
                        <td className="align-text-right"><strong>{convertToMonetary(total.cost)}</strong></td>
                        <td className="align-text-right"><strong>{convertToMonetary(total.profit)}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </ModalScreen>
    );
};
